import { useNavigate } from 'react-router';
import { useAuth } from '../../../contexts/AuthContext';
import { useCarrier } from '../../../contexts/CarrierContext';
import CarrierSwitcher from '../../carrier/CarrierSwitcher';
import CivilMeasurementsQueue from './CivilMeasurementsQueue';
import '../../../styles/AdminPage.css';
// The design role has a narrow workspace, not access to the administrator panel.
export default function DesignApprovalPage() {
  const { profile, signOut } = useAuth(); const { confirmLeave } = useCarrier(); const navigate = useNavigate();
  return <div className="admin-root" dir="rtl"><header className="admin-bar">
    <span className="admin-bar-brand">تأیید تیم طراحی اپراتور</span><CarrierSwitcher />
    <span className="admin-bar-user">{profile?.full_name}</span>
    <button className="admin-bar-exit" type="button" onClick={async () => { if (!await confirmLeave()) return; await signOut(); navigate('/login', { replace: true }); }}>خروج</button>
  </header><main className="admin-body"><CivilMeasurementsQueue /></main></div>;
}
